import React from "react";

const LinkGenerator = {
	link: ({ node, nodesToJSX }) => {
		const children = nodesToJSX({
			nodes: node.children,
		});

		const rel = node.attributes.external
			? "noopener noreferrer"
			: undefined;
		const target = node.attributes.external ? "_blank" : undefined;
		const href = node.attributes.to;

		return (
			<a
				href={href}
				{...{ rel, target }}
				style={{ textDecoration: "underline" }}
			>
				{children}
			</a>
		);
	},
};

export default LinkGenerator;
